var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencilEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.432 18.482L.04 24.864a1.768 1.768 0 00.478 1.626 1.83 1.83 0 001.623.475l6.361-1.397c.33-.072.633-.239.871-.478L25.45 8.995a5.3 5.3 0 000-7.493 5.412 5.412 0 00-7.483 0L1.915 17.612c-.24.238-.408.54-.483.87zM20.462 4a1.802 1.802 0 012.494 0 1.783 1.783 0 010 2.495l-1.247 1.249-2.495-2.498L20.461 4zm-15.7 15.741L16.712 7.75l2.469 2.485L7.227 22.23l-3.167.695.702-3.184z",
    fill: "#A4A4A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilEditIcon);
export default __webpack_public_path__ + "static/media/pencil-edit-icon.088fd8d3ffcadf5366c0409717052779.svg";
export { ForwardRef as ReactComponent };